import {
  SessionRole,
  Inserter,
  Wrapper,
  PartAdminMenu,
} from "nystem-components";

const PartAdmin = () => (
  <Inserter match="/admin*">
    <SessionRole userrole="logged-out">
      <Wrapper className="flex flex-col justify-center items-center ">
        <Inserter match="*" source="/user/login" />
      </Wrapper>
    </SessionRole>
    <SessionRole userrole="config super">
      <Wrapper className="m-auto max-w-6xl md:flex mt-10">
        <Wrapper className=" bg-white/30 p-1 md:pb-20 shadow-md flex md:block">
          <PartAdminMenu />
        </Wrapper>
        <Wrapper className="flex-grow px-3 pt-2 pb-32 max-w-3xl bg-white/70">
          <Inserter match="/admin" source="/page/list" />
          <Inserter match="/admin/content*" source="/content*" />
          <Inserter match="/admin/user*" source="/user*" />
          <Inserter match="/admin/page*" source="/page*" />
          <Inserter match="/admin/news*" source="/news*" />
          <Inserter match="/admin/menu*" source="/menu*" />
          <Inserter match="/admin/partner*" source="/partner*" />
          <Inserter match="/admin/tag*" source="/tag*" />
        </Wrapper>
      </Wrapper>
    </SessionRole>
  </Inserter>
);

export default PartAdmin;
